import { Cell, Header } from '@styles/ContactManager/DealCalculator/DealCalculatorStyles';
import { ILendersHeader } from '../interfaces';

export const DealCalculatorHeader = ({ headerData }: { headerData: ILendersHeader | undefined }) => {
  return (
    <Header>
      <Cell>
        <b>Contact</b> {headerData?.contactName}
      </Cell>

      <Cell>
        <b>State</b> {headerData?.state}
      </Cell>

      <Cell>
        <b>City</b> {headerData?.city}
      </Cell>

      <Cell>
        <b>Zip</b> {headerData?.zip}
      </Cell>

      <Cell>
        <b>Model Year</b> {headerData?.modelYear}
      </Cell>

      <Cell>
        <b>Make</b> {headerData?.make}
      </Cell>

      <Cell>
        <b>Model</b> {headerData?.model}
      </Cell>

      <Cell>
        <b>Odometer</b> {headerData?.odomter}
      </Cell>

      <Cell>
        <b>Vehicle Age</b> {headerData?.vehicleAge}
      </Cell>

      <Cell>
        <b>Vehicle Type</b> {headerData?.vehicleType}
      </Cell>

      <Cell>
        <b>PayOff</b> {headerData?.payOff}
      </Cell>

      <Cell>
        <b>Lead Source</b> {headerData?.leadSource}
      </Cell>
    </Header>
  );
};
